import { Button, Flex, Stack, Text } from "@chakra-ui/react";

import { ContactFormStep1 } from "./ContactFormStep1";
import { ContactFormStep2 } from "./ContactFormStep2";
import { InputField } from "./InputField";

import type { ContactFormStepProps } from "./ContactForm";

interface ContactFormStep3Props extends ContactFormStepProps {
	onFormSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
	errorMessage?: string;
	isSubmitting: boolean;
}

export const ContactFormStep3 = ({
	onFormSubmit,
	setFormStep,
	errorMessage,
	isSubmitting,
	...fieldProps
}: ContactFormStep3Props) => {
	return (
		<form onSubmit={onFormSubmit}>
			<Stack gap="4">
				<ContactFormStep1 isFinalStep {...fieldProps} />
				<ContactFormStep2 isFinalStep {...fieldProps} />

				<Flex w="100%" align="center" gap="4">
					<InputField
						{...fieldProps}
						isRequired={false}
						label="queries or requests"
						field="queries"
					/>

					<input
						type="hidden"
						name="access_key"
						value="ef10daa4-e212-4f52-b481-559ced1e66ee"
					/>

					<Button
						size="sm"
						rounded="3"
						type="submit"
						bg="brand.dark"
						color="brand.light"
						loadingText="Sending"
						fontFamily="Kalnia Variable"
						transition="background 200ms"
						_hover={{ bg: "brand.contrast" }}
						isLoading={isSubmitting}
					>
						SEND
					</Button>
				</Flex>

				{errorMessage && (
					<Text fontSize="sm" color="brand.contrast">
						{errorMessage}
					</Text>
				)}
			</Stack>
		</form>
	);
};
